import React, {useState, useEffect, useContext} from 'react'
import classes from './Calculator.module.scss'
import axios from 'axios';
import moment from 'moment';

import { LanguageContext } from '../../containers/Language';

import 'tooltipster/dist/css/tooltipster.bundle.css';
import Tooltipster  from 'react-tooltipster/dist/Tooltipster';

import { Element } from 'react-scroll'
import NumberFormat from 'react-number-format';

import {isMobile} from 'react-device-detect';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

const Calculator = () => {

    const {dictionary} = useContext(LanguageContext);
    
    const [GrossSalary, setGrossSalary] = useState(null);
    const [GrossInsuranceFee, setGrossInsuranceFee] = useState(null);
    const [Sector, setSector] = useState(null)
    const [startDate, setStartDate] = useState(new Date());
    const [calcResult, setCalcResult] = useState('');
    const [errorResult, seterrorResult] = useState()
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(false);
    const [maxGrossInsuranceFee, setMaxGrossInsuranceFee] = useState();

    const [GrossSalaryError, setGrossSalaryError] = useState();
    const [GrossInsuranceFeeError, setGrossInsuranceFeeyError] = useState();

    const [dateTimeError, setdateTimeError] = useState();

    const schema = yup.object().shape({
        GrossSalary : yup.number().typeError(dictionary.ERROR_REQUIRED).min(50, dictionary.LESS_50_ERR).required(dictionary.ERROR_REQUIRED),
        GrossInsuranceFee: yup.number().typeError(dictionary.ERROR_REQUIRED).min(50, dictionary.LESS_50_ERR).max(maxGrossInsuranceFee,  dictionary.MAX_GROSS_ERR.replace('{maxGrossInsuranceFee}', maxGrossInsuranceFee)).required(dictionary.ERROR_REQUIRED),
        Currency: yup.string().required().default("AZN"),
        Sector: yup.number().typeError(dictionary.SECTOR_ERR).positive().integer().required(dictionary.SECTOR_ERR),
        Birthdate: yup.string().required(dictionary.BIRTHDAY_ERR),
    });

    const dateChange = (value) =>{
        let minDate = moment(new Date()).subtract(16, 'y').format("DD.MM.YYYY");
        let maxDate = moment(new Date()).subtract(65, 'y').format("DD.MM.YYYY");
        setStartDate(moment(value).format('YYYY-MM-DD'))

        if(value > minDate){
            setdateTimeError("16 yaşdan aşağı seçim icazə yoxdur")
        }

        if(value < maxDate){
            setdateTimeError("65 yaşdan yuxarı seçim icazə yoxdur")
        }
    }

    const { register, handleSubmit, formState: { errors } } = useForm({
        reValidateMode: "onChange",
        resolver: yupResolver(schema)
      });

    
    useEffect(() => {
        if(Sector === "1"){
            setMaxGrossInsuranceFee((GrossSalary*45.02/100).toFixed(2))
        }else{
            if(GrossSalary <=373.8){
                setMaxGrossInsuranceFee((GrossSalary*45.02/100).toFixed(2))
            }else if(GrossSalary > 373.8){
                setMaxGrossInsuranceFee((GrossSalary*46.495/100).toFixed(2))
            }
        }
    }, [Sector, GrossSalary])

    const onSubmit = data => calculation(data);
    
    const calculation = async (data) => {

        setDisabled(true)
      
        await axios.get('https://soft.pasha-life.az/hyslandingpageapi/api/calculation', {
            params:data
        })
        .then((res) => {
            if(res.status === 200){
                setCalcResult(res.data)
                setError(false)
                setDisabled(false)
            }
        })
        .catch(error => {
            seterrorResult(error.response.data)
            setError(true)
            setDisabled(false)
         });
    };

    const checkKeyDown = (e) => {
        console.log(e.code)
        if (e.code === 'Enter' || e.code === 'NumpadEnter') e.preventDefault();
      };
    

    return (
        <Element name='calculator' className={classes.calculator}>
            <h3 dangerouslySetInnerHTML={{__html: dictionary.COLLECT_CALC}} className={`text-center ${classes.title}`}></h3>
            <div className={classes.calculatorInner}>
                    <div className={`${classes.calculatorBody} ${!calcResult && classes.NoneBorder}`}>
                        <form onSubmit={handleSubmit(onSubmit)} onKeyDown={(e) => checkKeyDown(e)}>
                            <div className='row'>
                                <div className={`col-md-6 ${classes.formGroup}`}>
                                    <div className='form-group'>
                                        <label>{dictionary.MONTHLY_AMOUNT}</label>
                                        <NumberFormat 
                                            allowNegative={false}
                                            disabled={disabled} 
                                            decimalScale='2'
                                            className={`form-control rounded shadow-1 ${errors.GrossInsuranceFee && `is-invalid`}`}
                                            autoComplete='off'
                                            {...register("GrossInsuranceFee")}
                                            placeholder={dictionary.ENTER_MONTHLY_AMOUNT}
                                            onChange={(e)=>setGrossInsuranceFee(e.target.value)} />

                                            <span class="icon right-icon">
                                                <Tooltipster trigger={isMobile ? 'click' : 'hover'} animation='grow' theme='tooltipster-default' content={<p className={`${classes.tooltip} mb-0`}>{dictionary.MONTHLY_AMOUNT_TOOPTIP}</p>} side='right'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24">
                                                        <g fill="none" fill-rule="evenodd">
                                                            <g fill="#BDC1C5" fill-rule="nonzero">
                                                                <g>
                                                                    <g>
                                                                        <g>
                                                                            <path
                                                                                d="M6.423 13.33l-.208.854c-.627.247-1.127.436-1.5.565-.373.13-.806.194-1.3.194-.758 0-1.348-.185-1.769-.554-.42-.37-.63-.84-.63-1.41 0-.22.015-.447.046-.678.032-.231.083-.492.153-.783l.783-2.77c.07-.266.129-.517.176-.755.048-.236.071-.454.071-.65 0-.353-.073-.6-.219-.74-.146-.139-.424-.209-.837-.209-.203 0-.41.032-.623.095-.213.063-.395.124-.547.18l.209-.854C.74 5.606 1.23 5.428 1.7 5.28c.469-.149.912-.223 1.33-.223.754 0 1.335.182 1.743.546.408.364.612.836.612 1.418 0 .12-.013.333-.042.636-.028.304-.08.582-.157.836l-.78 2.76c-.063.221-.12.474-.17.76-.052.283-.077.5-.077.644 0 .367.082.617.246.75.165.133.449.2.853.2.189 0 .405-.034.644-.1.24-.067.413-.125.521-.175zm.198-11.585c0 .48-.181.892-.545 1.23-.363.338-.801.508-1.313.508-.514 0-.952-.17-1.32-.509-.367-.338-.55-.748-.55-1.229 0-.48.183-.891.55-1.233C3.81.171 4.25 0 4.763 0c.512 0 .95.171 1.313.512.364.342.545.753.545 1.233z"
                                                                                transform="translate(-680 -860) translate(420 823) translate(260 37) translate(9 4.5)" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </Tooltipster>
                                            </span>
                                            
                                        {errors.GrossInsuranceFee && <div className="error-notification">{errors.GrossInsuranceFee.message}</div>}
                                    </div>
                                </div>

                                <div className={`col-md-6 ${classes.formGroup}`}>
                                    <div className='form-group'>
                                        <label>{dictionary.SALARY}</label>

                                        <NumberFormat 
                                            allowNegative={false}
                                            disabled={disabled} 
                                            mask="_"
                                            decimalScale='2'
                                            className={`form-control rounded shadow-1 ${errors.GrossSalary && `is-invalid`}`}
                                            autoComplete='off'
                                            {...register("GrossSalary")}
                                            placeholder={dictionary.ENTER_SALARY}
                                            onChange={(e)=>setGrossSalary(e.target.value)} />
                                            <span class="icon right-icon ">
                                                <Tooltipster trigger={isMobile ? 'click' : 'hover'} animation='grow' theme='tooltipster-default' content={<p className={`${classes.tooltip} mb-0`}>{dictionary.SALARY_TOOLTIP}</p>} side='right'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24">
                                                            <g fill="none" fill-rule="evenodd">
                                                                <g fill="#BDC1C5" fill-rule="nonzero">
                                                                    <g>
                                                                        <g>
                                                                            <g>
                                                                                <path
                                                                                    d="M6.423 13.33l-.208.854c-.627.247-1.127.436-1.5.565-.373.13-.806.194-1.3.194-.758 0-1.348-.185-1.769-.554-.42-.37-.63-.84-.63-1.41 0-.22.015-.447.046-.678.032-.231.083-.492.153-.783l.783-2.77c.07-.266.129-.517.176-.755.048-.236.071-.454.071-.65 0-.353-.073-.6-.219-.74-.146-.139-.424-.209-.837-.209-.203 0-.41.032-.623.095-.213.063-.395.124-.547.18l.209-.854C.74 5.606 1.23 5.428 1.7 5.28c.469-.149.912-.223 1.33-.223.754 0 1.335.182 1.743.546.408.364.612.836.612 1.418 0 .12-.013.333-.042.636-.028.304-.08.582-.157.836l-.78 2.76c-.063.221-.12.474-.17.76-.052.283-.077.5-.077.644 0 .367.082.617.246.75.165.133.449.2.853.2.189 0 .405-.034.644-.1.24-.067.413-.125.521-.175zm.198-11.585c0 .48-.181.892-.545 1.23-.363.338-.801.508-1.313.508-.514 0-.952-.17-1.32-.509-.367-.338-.55-.748-.55-1.229 0-.48.183-.891.55-1.233C3.81.171 4.25 0 4.763 0c.512 0 .95.171 1.313.512.364.342.545.753.545 1.233z"
                                                                                    transform="translate(-680 -860) translate(420 823) translate(260 37) translate(9 4.5)" />
                                                                            </g>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                </Tooltipster>
                                                </span>
                                        {errors.GrossSalary && <div className="error-notification">{errors.GrossSalary.message}</div>}
                                    </div>
                                </div>

                                <div className={`col-md-6 ${classes.formGroup}`}>
                                    <div className='form-group mb-0'>
                                        <label>{dictionary.BIRTHDAY}</label>
                                        <NumberFormat 
                                            format="##.##.####" 
                                            placeholder="gg.aa.iiii" 
                                            mask={['_', '_', '_', '_', '_', '_', '_', '_']}
                                            disabled={disabled} 
                                            autoComplete='off'
                                            {...register("Birthdate")}
                                            onChange={e => setStartDate(moment(e.target.value).format("DD.MM.YYYY"))}
                                            className={`form-control rounded shadow-1 ${errors.Birthdate && `is-invalid`}`}
                                            maskChar={null} />

                                        {errors.Birthdate && <div className="error-notification">{errors.Birthdate.message}</div>}
                                        
                                    </div>
                                </div>

                                <div className={`col-md-6 ${classes.formGroup}`}>
                                    <div className='form-group mb-0'>
                                        <label for="">{dictionary.WORK_PLACE}</label>
                                        <div onChange={(e) =>setSector(e.target.value)}>
                                            <input {...register("Sector")} className="radio-1" value='1' type="radio" id="s-1" />
                                            <label for="s-1">{dictionary.PUBLIC_SECTOR}</label>
                                            <input {...register("Sector")} className="radio-1" value='2' type="radio" id="s-2" />
                                            <label for="s-2">{dictionary.PRIVATE_SECTOR}</label>
                                        </div>
                                        {errors.Sector && <div className="error-notification">{errors.Sector.message}</div>}
                                    </div>
                                </div>

                                <div className={`col-md-6 mb-0 ${classes.formGroup}`}>
                                    {/* <label for="">Valyuta</label>
                                    <div className="radio-inline">
                                        <input className="radio-1" type="radio" id="azn" name="currency"/>
                                        <label for="azn">AZN</label>

                                        <input className="radio-1" type="radio" id="usd" name="currency"/>
                                        <label for="usd">USD</label>
                                    </div> */}
                                </div>

                                <div className={`col-md-6 mb-0 ${classes.formGroup}`}>
                                    <label for="">&nbsp;</label>
                                    <button disabled={disabled} type='submit' className="btn btn-primary w-100">{disabled ? (<><div class="spinner-border"></div> {dictionary.WAIT}</>) : dictionary.COUNT}</button>
                                </div>

                                <span className={`${classes.span} ${!calcResult && `d-none`}`}>{dictionary.CALC_INFO_TXT}<label>*</label></span>
                            </div>
                        </form>
                    </div>

                    {error ?
                         <div className={`${classes.calculatorFooter}`}>
                            <div className={classes.footerSection}>
                                <span className={classes.error}>{errorResult.errors.Birthdate === "Age must be between 16 and 65"? "Yaş 16 və 65 yaş aralığında olmalıdır" : dictionary.BIRTHDAY_API_ERR}</span>
                            </div>
                        </div> : 
                        <div className={`${classes.calculatorFooter} ${!calcResult && `d-none`}`}>
                            <div className={classes.footerSection}>
                                <span>{dictionary.CUSTOM_COLL_TXT}</span>
                                <p className='mb-0'>{calcResult.personalInvestment} AZN</p>
                            </div>
                            <div className={classes.footerSection}>
                                <span dangerouslySetInnerHTML={{__html:dictionary.HYS_COLL_TXT }}></span>
                                <p className='mb-0'>{calcResult.hysInvestment} AZN</p>
                            </div>
                        </div>
                    }
                </div>
        </Element>
    )
}

export default Calculator
